<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12">
                <v-row no-gutters cols="12" class="my-3 justify-center">
                    <v-col cols="2">
                        <v-btn-primary block @click="open_CI_creator()"> Ajouter </v-btn-primary>
                    </v-col>
                    <v-col cols="10" class="pl-2">
                        <v-text-field
                            v-model="search"
                            append-inner-icon="$search"
                            clearable
                            @click:clear="search = ''"
                            label="Recherche"
                            outlined
                            hide-details
                            density="compact"
                        />
                    </v-col>
                    <!-- <v-col cols="2" class="pl-2">
                        <v-combobox
                            v-model="filterCompany"
                            :items="allAvailableCompanies"
                            label="Société"
                            hide-details
                        >
                        </v-combobox>
                    </v-col> -->
                </v-row>
            </v-col>
            <RuleTable
                :rule="'computedIndicator'"
                :items="filteredComputedIndicators"
                :getTitle="displayIndicatorName"
                :hideDuplication="true"
                :accountingCompanyId="companyId"
                :patternCount="computedIndicatorCount"
                :pagination="pagination"
                :firstRequestDone="firstRequestDone"
                :maxHeight="maxHeightRT"
                @to-route="open_CI_creator($event)"
                @delete="
                    computedIndicatorToDelete = $event;
                    deleteDialog = true;
                "
            ></RuleTable>
        </v-row>
        <oss-dialog
            v-model="CI_creatorDialog"
            min-width="80vw"
            :title="selectedIndicator ? 'Modifier un indicateur' : 'Créer un nouvel indicateur'"
            :hideValid="selectedIndicatorIsReadonly"
            :actions="CI_creatorActions"
        >
            <h2>Le nouvel indicateur :</h2>
            <ComputedIndicatorCreator
                :incomingData="selectedIndicator"
                :companyId="companyId"
                :readOnly="selectedIndicatorIsReadonly"
                :actions="CI_creatorActions"
                :scopeId="scopeId"
                :watchScope="true"
                @computedIndicatorSavedInBDD="CI_created($event)"
            ></ComputedIndicatorCreator>
            <div class="pt-2">
                <v-divider />
                <ScopeManager
                    v-model="scopeSync"
                    v-model:id="scopeId"
                    v-model:name="scopeName"
                    :readonly="selectedIndicatorIsReadonly"
                />
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @close="computedIndicatorToDelete = undefined"
            @valid="deletePattern"
            :validLoading="deleteLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer cet indicateur ?</h4>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { User } from "../../store/store";

import { Apollo } from "@/decorators";

import COMPUTED_INDICATORS from "../../graphql/ComputedIndicators.gql";

import ScopeManager from "../companyScope/ScopeManager.vue";
import ComputedIndicatorCreator from "../computedIndicator/ComputedIndicatorCreator.vue";

import { Component, Model, Vue, toNative } from "vue-facing-decorator";
import { DialogAction } from "../../services/dialogAction";
import RuleTable from "./RuleTable.vue";

@Component({
    components: {
        ComputedIndicatorCreator,
        ScopeManager,
        RuleTable,
    },
})
export class ComputedIndicatorTable extends Vue {
    @Model({ type: String, name: "companyScope" }) scopeSync!: any;

    firstRequestDone = false;

    loadingStateNext = true;

    pagination: any = {
        page: 1,
        rowsPerPage: 20,
        sortBy: "name",
    };

    computedIndicatorCount: number = 0;

    search = "";

    filterCompany = null;

    CI_creatorDialog = false;
    selectedIndicator = null;

    CI_creatorActions = {
        action: new DialogAction(),
    };

    scopeName: string = "";
    scopeId_: string = "";

    get scopeId() {
        if (this.scopeSync?.id) {
            this.scopeId_ = this.scopeSync?.id;
        }
        return this.scopeId_;
    }

    set scopeId(value) {
        this.scopeId_ = value;
    }

    open_CI_creator(item = null) {
        this.selectedIndicator = item;
        if (item?.companyScope) {
            this.scopeId = item.companyScope.id;
            this.scopeName = item.companyScope.name;
        } else {
            this.scopeId = "";
            this.scopeName = "";
        }
        this.CI_creatorDialog = true;
    }

    get filterCompanyId() {
        return this.filterCompany?.title && this.filterCompany?.value
            ? this.filterCompany.value
            : null;
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                title: company.name,
            });
            companies.sort((a, b) => {
                if (a.title < b.title) return -1;
                if (a.title > b.title) return 1;
                return 0;
            });
        });
        companies.unshift({ value: "", title: "Toutes mes règles" });

        return companies;
    }

    get companyId() {
        return this.$store.state.user.company.id;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isRootProfile() {
        return this.currentUser.isRoot;
    }

    get selectedIndicatorIsReadonly(): boolean {
        return (
            this.selectedIndicator &&
            !(
                this.selectedIndicator.companyScope?.accountingCompanyOwner &&
                this.selectedIndicator.companyScope?.accountingCompanyOwner.id === this.companyId
            )
        );
    }

    get maxHeightRT() {
        return "calc(100vh - 160px)";
        const innHeight = window.innerHeight;
        const vhHeight = (200 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    // regexp = /v\d/g;

    // getDisplayExpressionTitle(computedIndicator) {
    //     let result = computedIndicator.operator;
    //     const numberOfOperations = Array.from(computedIndicator.operator.matchAll(this.regexp)).length
    //     for (let index = 1; index <= numberOfOperations; index++) {
    //         const replacementText = computedIndicator.values[index - 1]
    //             ? this.displayIndicatorName(computedIndicator)
    //             : "";
    //         result = result.replace("v" + index, replacementText);
    //     }
    //     return result;
    // }

    displayIndicatorName(item): string {
        const computedIndicator = item.definition;
        if (computedIndicator.displayName) {
            return computedIndicator.displayName;
        }
        let result = computedIndicator.operator;
        for (const v of computedIndicator.values) {
            result = result.replace(v.operationName, v.displayName);
        }
        if (result[0] === "-") {
            result = result.replace("-", "");
        }
        return result;
    }

    get where() {
        let OR = [];
        if (this.isRootProfile) {
            OR = [
                { companyScope: { accountingCompanyOwner: { id: this.companyId } } },
                { companyScope: { scopeSharingStatus: "VALIDATE", accountingCompany: null } },
                { companyScope: { scopeSharingStatus: "PENDING_VALIDATION" } },
            ];
        } else {
            OR = [
                { companyScope: { accountingCompanyOwner: { id: this.companyId } } },
                { companyScope: { scopeSharingStatus: "VALIDATE", accountingCompany: null } },
            ];
        }
        // if (this.search) {
        //     return {
        //         AND: [
        //             {
        //                 OR: [
        //                     { name_contains: this.search },
        //                     { clients_some: { name_contains: this.search } },
        //                 ],
        //             },
        //             {
        //                 OR,
        //             },
        //         ],
        //     };
        // }
        return { OR };
    }

    get filteredComputedIndicators() {
        const result = [];
        if (this.search == "") {
            return this.computedIndicators;
        }
        for (const cIs of this.computedIndicators) {
            if (this.displayIndicatorName(cIs).toLowerCase().includes(this.search.toLowerCase())) {
                result.push(cIs);
            }
        }
        return result;
    }

    @Apollo({
        query: COMPUTED_INDICATORS,
        variables() {
            return {
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                where: this.where,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.firstRequestDone = true;
                    this.computedIndicators.length = 0;
                    this.computedIndicators.push(...data.computedIndicators);
                    this.computedIndicatorCount = data.computedIndicatorsConnection.aggregate.count;
                } else {
                    this.items = [];
                    this.pagination.page = 1;
                    this.computedIndicatorCount = 0;
                }
            }
        },
    })
    computedIndicators: any = [];

    computedIndicatorToDelete;
    deleteDialog = false;
    deleteLoading = false;

    async deletePattern() {
        this.deleteLoading = true;
        if (this.computedIndicatorToDelete) {
            const deletedCI = await this.$apollo.mutate({
                mutation: gql`
                    mutation DeleteComputedIndicator($id: ID!) {
                        deleteComputedIndicator(where: { id: $id }) {
                            id
                            companyScopeId
                        }
                    }
                `,
                variables: {
                    id: this.computedIndicatorToDelete.id,
                },
            });
            // await this.$apollo.mutate({
            //     mutation: gql`
            //         mutation DeleteCompanyScope($id: ID!) {
            //             deleteCompanyScope(where: { id: $id }) {
            //                 id
            //             }
            //         }
            //     `,
            //     variables: {
            //         id: deletedCI.data.deleteComputedIndicator.companyScopeId,
            //     },
            // });
            this.computedIndicatorToDelete = undefined;
            this.refresh();
        }
        this.deleteDialog = false;
        this.deleteLoading = false;
    }

    async CI_created(event) {
        await this.$apollo.mutate({
            mutation: gql`
                mutation ($id: ID!, $companyScopeId: ID!) {
                    updateComputedIndicator(
                        where: { id: $id }
                        data: { companyScope: { connect: { id: $companyScopeId } } }
                    ) {
                        id
                    }
                }
            `,
            variables: {
                id: event.id,
                companyScopeId: this.scopeId,
            },
        });
        this.refresh();
        this.CI_creatorDialog = false;
        this.selectedIndicator = null;
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.computedIndicators) {
            this.$apollo.queries.computedIndicators.refetch();
        } else {
            debugger;
        }
    }
}

export default toNative(ComputedIndicatorTable);
</script>
